import { consumirServicioEncirptacion } from 'api';
import { enviar } from 'api/funcionesPrueba';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { inputNumericoEnteros } from 'components/InputsMex/validaciones';
import { ambienteAplicacion, urlCatalogosCotizador } from 'constants/urls';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { regex } from 'utils/validaciones';
import { DropDownFilter, TextInput } from './componentes/entradas';
import { Hogar } from './constantes/general';

const valorValido = (objeto) => {
  try {
    if (objeto) {
      return 'id' in objeto && 'nombre' in objeto;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const solicitarCatalogos = async (descripcion = '', parametros = {}) => {
  const body = {
    ambiente: ambienteAplicacion,
    prodCodigo: Hogar.codProducto,
    prodCodigoCore: Hogar.prodCodigoCore,
    pasoCodigo: 'informacionGeneral',
    datosCotizador: {
      prodCodigo: Hogar.codProducto,
      cotPasoCodigo: {
        descripcion,
        parametros,
      },
    },
  };

  let respuesta;
  if (Hogar.encriptar.catalogo) {
    respuesta = await consumirServicioEncirptacion(urlCatalogosCotizador, body);
  } else {
    respuesta = await enviar(urlCatalogosCotizador, body);
  }

  return respuesta;
};

const useRellenarLocaciones = (params = {}) => {
  const { watch, setValue } = useFormContext();

  const pathCodPostal = params?.names?.codPostal;
  const pathEstado = params?.names?.estado;
  const pathMunicipio = params?.names?.municipio;
  const pathColonia = params?.names?.colonia;

  const estadosCompletos = params?.catalogoEstados;

  const { addWarningToast } = useCustomToast();

  const [busquedaAutomatica, setBusquedaAutomatica] = useState(false);
  const [catEstados, setCatEstados] = useState(estadosCompletos);
  const [catMunicipios, setCatMunicipios] = useState();
  const [catColonias, setCatColonias] = useState();

  const [cargaEstados, setCargaEstados] = useState(false);
  const [cargaMunicipios, setCargaMunicipios] = useState(false);
  const [cargaColonias, setCargaColonias] = useState(false);
  const [usuIngresoCodPostal, setUsuIngresoCodPostal] = useState(false);

  const zipSeleccionado = watch(pathCodPostal);
  const estadoSeleccionado = watch(pathEstado);
  const municipioSeleccionado = watch(pathMunicipio);
  const coloniaSeleccionada = watch(pathColonia);

  //Si no existe el catalogo y ya se guardaron valores anteriormente, se precargan dichos valores como catalogo
  useEffect(() => {
    if (!catEstados && estadoSeleccionado) {
      setCatEstados([{ estado: estadoSeleccionado }]);
    }
  }, [catEstados, estadoSeleccionado]);

  useEffect(() => {
    if (!catMunicipios && municipioSeleccionado) {
      setCatMunicipios([{ municipio: municipioSeleccionado }]);
    }
  }, [catMunicipios, municipioSeleccionado]);

  useEffect(() => {
    if (!catColonias && coloniaSeleccionada) {
      setCatColonias([{ colonia: coloniaSeleccionada }]);
    }
  }, [catColonias, coloniaSeleccionada]);

  /**Relleno locaciones**/
  const handleBuscarCodPostal = (e) => {
    const ejecutar =
      valorValido(estadoSeleccionado) &&
      valorValido(municipioSeleccionado) &&
      valorValido(e);

    if (ejecutar) {
      setBusquedaAutomatica(false);
      const solicitudCodPostal = async () => {
        const respCodPostal = await solicitarCatalogos('codigoPostal', {
          colonia: e?.id,
          estado: estadoSeleccionado?.id,
          municipio: municipioSeleccionado?.id,
        });
        if (
          respCodPostal?.transaccion === true &&
          respCodPostal?.catalogo?.disponible === true
        ) {
          const codPostales = respCodPostal?.catalogo?.codPostal;

          if (codPostales.length === 1) {
            const codPostal = codPostales[0];
            setValue(pathCodPostal, codPostal, {
              shouldValidate: true,
            });
          }
        } else if (
          respCodPostal?.transaccion === true &&
          respCodPostal?.catalogo?.disponible === false &&
          respCodPostal?.catalogo?.mensaje
        ) {
          addWarningToast(respCodPostal?.catalogo?.mensaje, {
            autoDismiss: false,
          });
        }
      };
      solicitudCodPostal();
    }
  };

  const handleBuscarEstados = (e) => {
    setBusquedaAutomatica(true);
    setUsuIngresoCodPostal(true);

    if (!zipSeleccionado) {
      setCatEstados(estadosCompletos);
      setValue(pathEstado, '', {
        shouldValidate: false,
      });
    }

    if (zipSeleccionado && busquedaAutomatica && zipSeleccionado?.length === 5) {
      const solicitudRellenar = async () => {
        setValue(pathEstado, '', {
          shouldValidate: false,
        });
        setValue(pathMunicipio, '', {
          shouldValidate: false,
        });
        setValue(pathColonia, '', {
          shouldValidate: false,
        });
        setCargaEstados(true);
        setCargaMunicipios(true);
        setCargaColonias(true);
        const respRellenar = await solicitarCatalogos('rellenar', {
          codigoPostal: zipSeleccionado,
        });

        if (
          respRellenar?.transaccion === true &&
          respRellenar?.catalogo?.disponible === true
        ) {
          const estado = respRellenar?.catalogo?.estado?.estado;
          const municipios = respRellenar?.catalogo?.municipio;
          const colonias = respRellenar?.catalogo?.colonias;

          setValue(pathEstado, estado, {
            shouldValidate: true,
          });

          setCatMunicipios(municipios);
          if (municipios?.length === 1) {
            const municipio = municipios[0]?.municipio;
            setValue(pathMunicipio, municipio, {
              shouldValidate: true,
            });
          }

          setCatColonias(colonias);
          if (colonias?.length === 1) {
            const colonia = colonias[0]?.colonia;
            setValue(pathColonia, colonia, {
              shouldValidate: true,
            });
          }
        } else if (
          respRellenar?.transaccion === true &&
          respRellenar?.catalogo?.disponible === false &&
          respRellenar?.catalogo?.mensaje
        ) {
          addWarningToast(respRellenar?.catalogo?.mensaje, {
            autoDismiss: false,
          });
        }
        setCargaEstados(false);
        setCargaMunicipios(false);
        setCargaColonias(false);
      };

      solicitudRellenar();
    }
  };

  const solicitudMunicipios = async (estado, codigoPostal = '') => {
    setCargaMunicipios(true);
    setCargaColonias(true);
    const respMunicipio = await solicitarCatalogos('municipios', {
      codigoPostal,
      estado,
    });

    if (respMunicipio.transaccion) {
      const municipios = respMunicipio?.catalogo?.municipios;
      setCatMunicipios(municipios);
      if (municipios.length === 1) {
        const municipio = municipios[0]?.municipio;
        setValue(pathMunicipio, municipio, {
          shouldValidate: true,
        });
      } else {
        setValue(pathMunicipio, '', {
          shouldValidate: true,
        });
      }
    }
    setCargaMunicipios(false);
    setCargaColonias(false);
  };

  const handleBuscarMunicipios = (e) => {
    setUsuIngresoCodPostal(false);

    setValue(pathCodPostal, '', {
      shouldValidate: false,
    });
    setValue(pathMunicipio, '', {
      shouldValidate: false,
    });
    setValue(pathColonia, '', {
      shouldValidate: false,
    });
    solicitudMunicipios(e?.id);
  };

  const solicitudColonias = async (municipio, estado, codigoPostal = '') => {
    setCargaColonias(true);
    const respColonia = await solicitarCatalogos('colonias', {
      codigoPostal,
      estado,
      municipio: municipio,
    });
    if (respColonia.transaccion) {
      const colonias = respColonia?.catalogo?.colonias;
      setCatColonias(colonias);
      if (colonias.length === 1) {
        const colonia = colonias[0]?.colonia;
        setValue(pathColonia, colonia, {
          shouldValidate: true,
        });
      } else {
        setValue(pathColonia, '', {
          shouldValidate: true,
        });
      }
    }
    setCargaColonias(false);
  };

  const handleBuscarColonias = (e) => {
    let codPostalSeleccionado = watch(pathCodPostal);
    if (usuIngresoCodPostal === false) {
      setValue(pathCodPostal, '', {
        shouldValidate: false,
      });
      codPostalSeleccionado = '';
    }

    setValue(pathColonia, '', {
      shouldValidate: false,
    });
    solicitudColonias(e?.id, estadoSeleccionado?.id, codPostalSeleccionado);
  };

  const componenteCodigoPostal = (
    <SimpleContainer
      label={'Código postal del inmueble a asegurar'}
      name={pathCodPostal}
    >
      <TextInput
        inputProps={{
          name: pathCodPostal,
          type: 'number',
          onKeyDown: inputNumericoEnteros,
        }}
        extrasClasses="hide-arrows"
        onChangeFn={(e) => handleBuscarEstados(e)}
        rules={{
          required: regex.requiredMessage,
          pattern: {
            value: regex.codPostal.value,
            message: regex.codPostal.mensaje,
          },
        }}
      />
    </SimpleContainer>
  );

  const componenteEstado = (
    <SimpleContainer label="Estado" name={pathEstado}>
      <DropDownFilter
        name={pathEstado}
        optionLabel="estado.nombre"
        optionValue="estado"
        onChangeFn=""
        options={catEstados}
        loading={cargaEstados}
        helpText={'Seleccione un estado'}
        rules={{ required: regex.requiredMessage }}
        onSelect={(e) => handleBuscarMunicipios(e)}
      />
    </SimpleContainer>
  );
  const componenteMunicipio = (
    <SimpleContainer label="Municipio" name={pathMunicipio}>
      <DropDownFilter
        name={pathMunicipio}
        optionLabel="municipio.nombre"
        optionValue="municipio"
        onChangeFn=""
        options={catMunicipios}
        loading={cargaMunicipios}
        helpText={'Seleccione un municipio'}
        rules={{ required: regex.requiredMessage }}
        onSelect={handleBuscarColonias}
      />
    </SimpleContainer>
  );
  const componenteColonia = (
    <SimpleContainer label="Colonia" name={pathColonia}>
      <DropDownFilter
        name={pathColonia}
        optionLabel="colonia.nombre"
        optionValue="colonia"
        onChangeFn=""
        options={catColonias}
        loading={cargaColonias}
        helpText={'Seleccione una colonia'}
        rules={{ required: regex.requiredMessage }}
        onSelect={handleBuscarCodPostal}
      />
    </SimpleContainer>
  );

  return {
    componenteCodigoPostal,
    componenteEstado,
    componenteMunicipio,
    componenteColonia,
  };
};

export default useRellenarLocaciones;
